"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _1 = require(".");
const ListGroup = ({ children, separator }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { style: { height: 24, width: '100%', position: 'relative' } },
        React.createElement("div", { style: {
                backgroundColor: _1.quartz,
                height: 24,
                width: 4,
                left: 26,
                position: 'absolute',
            } })),
    React.createElement("div", { style: {
            backgroundColor: _1.quartz,
            borderRadius: 4,
            display: 'flex',
            flexDirection: 'column',
        } }, React.Children.map(children, (child, index) => (React.createElement(React.Fragment, { key: index },
        index > 0 && index < React.Children.count(children) - 1
            ? React.cloneElement(separator, {
                style: {
                    alignSelf: 'center',
                    backgroundColor: _1.quartz,
                    height: 16,
                    padding: '0 4px',
                    position: 'relative',
                    top: -8,
                },
            })
            : undefined,
        React.createElement("div", { key: index, style: {
                borderBottom: index < React.Children.count(children) - 1 ? `1px solid ${_1.silver}` : 'none',
                margin: '0 16px',
                padding: index > 0 && index < React.Children.count(children) - 1 ? '0 0 16px' : '16px 0 15px',
            } }, child))))),
    React.createElement("div", { style: { height: 24, width: '100%', position: 'relative' } },
        React.createElement("div", { style: {
                backgroundColor: _1.quartz,
                height: 24,
                width: 4,
                left: 26,
                position: 'absolute',
            } }))));
exports.default = ListGroup;
